import React, { createContext, useContext, useReducer } from "react";

export const TegContext = createContext(null);
export const TegProvider = ({ reducer, initialState, children }) => (
  <TegContext.Provider value={useReducer(reducer, initialState)}>
    {children}
  </TegContext.Provider>
);
export const useTeg = () => useContext(TegContext);
